export const setupTour = {
  id: 'setup-tour',
  steps: [
    {
      route: '/dashboard',
      element: '[data-tour="dashboard-header"]',
      title: 'Bem-vindo ao RSVPFY!',
      description: 'Este é o Dashboard do seu evento. Aqui você acompanha métricas, inscrições e o progresso da configuração.',
      side: 'bottom'
    },
    {
      route: '/dashboard',
      element: '[data-tour="checklist"]',
      title: 'Checklist de Configuração',
      description: 'Siga as 3 fases para configurar seu evento: Configurar → Publicar → Gerenciar. Cada item leva direto para a página certa.',
      side: 'bottom'
    },
    {
      route: '/settings/event',
      element: '[data-tour="event-settings"]',
      title: '1. Informações do Evento',
      description: 'Preencha nome, datas, local e modo do evento. Essas informações aparecerão na landing page e nos emails.',
      side: 'right'
    },
    {
      route: '/settings/groups',
      element: '[data-tour="groups-list"]',
      title: '2. Grupos de Participantes',
      description: 'Grupos organizam seus convidados (ex: VIP, Imprensa, Convidados). Crie pelo menos 1 grupo — ele é necessário para o formulário.',
      side: 'bottom'
    },
    {
      route: '/settings/forms',
      element: '[data-tour="forms-list"]',
      title: '3. Formulário de Inscrição',
      description: 'Crie o formulário que seus participantes vão preencher. Associe-o a um grupo e personalize os campos.',
      side: 'bottom'
    },
    {
      route: '/settings/rsvp',
      element: '[data-tour="rsvp-settings"]',
      title: '4. Configurações de Inscrição',
      description: 'Defina o modo de inscrição, grupo padrão e limites. Quando tudo estiver pronto, ative as inscrições aqui.',
      side: 'right'
    },
    {
      route: '/settings/site',
      element: '[data-tour="lp-customization"]',
      title: '5. Landing Page',
      description: 'Personalize a página de inscrição com banner, cores e conteúdo. Esta é a página que seus convidados verão.',
      side: 'bottom'
    },
    {
      route: '/dashboard',
      element: '[data-tour="checklist"]',
      title: 'Pronto para começar!',
      description: 'Volte ao checklist sempre que precisar. Quando tudo estiver verde, seu evento está pronto!',
      side: 'bottom'
    }
  ]
}
